import styled from 'styled-components';

const VCContent = styled.div``;

export default VCContent;